export default __webpack_public_path__ + "static/media/vending_logo_2.d265ecd7.png";